@if (data(); as cellData) {
	<div class="sh-device-name-cell" [class.sh-offline-device]="isOffline()">
		<span class="sh-device-name-container">
			@if (!params.shouldHideStateBar && !cellData.hideStateBar) {
				<sh-device-state-bar class="sh-device-state" [deviceStatus]="cellData.status"></sh-device-state-bar>
			}
			@if (!cellData.hideImage) {
				<sh-device-image
					class="sh-device-image"
					[deviceModel]="cellData.model"
					[isPasswordEnabled]="cellData.isPasswordEnabled"
					[isAuthenticated]="cellData.isAuthenticated"
					[channelCount]="cellData.channelCount"
					[isOffline]="isOffline()"
				></sh-device-image>
			}
			@if (params.renderDeviceNameAsText) {
				<span class="sh-device-name-text">{{ cellData.name.name }}</span>
			} @else {
				<sh-inline-device-name-input
					[value]="!cellData.hideName ? cellData.name.name : '--'"
					(deviceNameChanged)="updateDeviceName(cellData.id, $event)"
					(errorMessageHeight)="displayErrorMessage(cellData.id, $event)"
					[disabled]="
						cellData.name.isDisabled || params.isDeviceNameReadonly || isOffline() || hasError() || isNew()
					"
					[isDiscovered]="isDiscovered()"
					[constraints]="cellData.name.constraints"
				></sh-inline-device-name-input>
			}
		</span>

		@if (!params.shouldHideIdentify) {
			@if (cellData.identify; as identify) {
				<sh-id-button
					[class.sh-absolute]="!params.renderDeviceNameAsText"
					[disabled]="identify.isDisabled || (isIdentifyDisabled$ | async) === true"
					[isIdentifying]="(isIdentifying$ | async) || identify.isIdentifying || false"
					(toggleIdentify)="setIdentify(cellData.id, !!identify.isIdentifying)"
				></sh-id-button>
			} @else {
				<!-- empty placeholder for grid alignment when device has no ID button -->
				<div class="sh-id-placeholder"></div>
			}
		}
	</div>
} @else {
	<span>--</span>
}
